import { HttpRequest, HttpResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import { ToastService } from 'src/app/data/services/components/toast/toast.service'
import { LogService } from 'src/app/data/services/erp/log/log.service'
import { ToastSeverity } from 'src/app/domain/enums/components/toast.enum'
import { LogAction, LogFunction, LogModule, LogScreen } from 'src/app/domain/enums/erp/log.enum'
import { Toast } from 'src/app/domain/interfaces/components/toast.interface'
import { LogAuxiliaryData } from '../../../models/erp/log/log-auxiliary-data.model'

export class LogRmsManagement {

  private logService: LogService = inject(LogService)
  private toastService: ToastService = inject(ToastService)

  public generateLog(request: HttpRequest<any>, response: HttpResponse<any>, auxiliaryData: LogAuxiliaryData): void {
    if (response.status !== 200) return

    try {
      switch (auxiliaryData.function) {
        case LogFunction.DELETE_RMS:
          this.generateLogDeleteRms(request, response, auxiliaryData.data)
        break
      }
    } catch (error) {
      this.toastService.sendToast({ severity: ToastSeverity.ERROR, message: error } as Toast)
    }
  }

  private generateLogDeleteRms(request: HttpRequest<any>, response: HttpResponse<any>, auxiliaryData: any): void {
    const screen = this.getLogScreen(auxiliaryData.rmsType)
    
    auxiliaryData.selectedRmsList.forEach((rms: any) => {
      this.logService.create(
        LogModule.RMS,
        screen,
        request.urlWithParams,
        LogAction.DELETE,
        rms.id,      
        rms.key,       
        `O RMS ${rms.titulo} foi excluído`, 
        request.body
      )
    })
  }

  private getLogScreen(rmsType: 'purchases' | 'sales' | 'basic'): LogScreen {
    switch (rmsType) {
      case 'purchases':
        return LogScreen.RMS_PURCHASES      
      break
      case 'sales':
        return LogScreen.RMS_SALES
      break
      case 'basic':
        return LogScreen.RMS_SIMPLIFIED
      break
    }
  }
}